import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken, getBatchFetcher } from '~/api/utils'
import type { ApplicantSafetyCheck } from '../types'

type ApplicantSafetyCheckWithId = ApplicantSafetyCheck & { id: number }

const applicantSafetyChecksBatcher = () =>
  getBatchFetcher<ApplicantSafetyCheckWithId>(
    'applicantSafetyChecks',
    async (ids) => {
      const safetyChecks = await fetchApiWithToken<ApplicantSafetyCheck[]>({
        method: 'get',
        url: `/v1/applicants/safety_checks?id[]=${ids.join('&id[]=')}&itemsPerPage=1000`
      })

      return safetyChecks.map((safetyCheck) => {
        return {
          ...safetyCheck,
          id: safetyCheck.applicant.id
        }
      })
    }
  )

export const useApplicantSafetyCheck = ({
  applicantId,
  enabled = true
}: {
  applicantId?: number
  enabled?: boolean
}) => {
  return useQuery({
    queryKey: ['applicants', 'safetyChecks', applicantId],
    queryFn: () =>
      applicantId
        ? applicantSafetyChecksBatcher().fetch(applicantId)
        : Promise.resolve(null),
    enabled: !!applicantId && enabled,
    staleTime: 300_000,
    refetchOnWindowFocus: false
  })
}
